import { IQueryContext } from 'framework/context/IQueryContext';
import { IHolidayPeriod, IHolidayPeriodsQueryParams, IQueryResult } from 'gen/ApiClient';
import React from 'react';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IHolidayPeriod>, IHolidayPeriodsQueryParams>>(undefined as any);